<template>
    <div :data-theme="theme === 'dark' ? 'dark' : 'light'">
        <div class="inner-header-bg">
            <innerheader />
        </div>
        <SPManagement />
    </div>
</template>

<script>
import innerheader from "@/components/header/innerHeader.vue";
import SPManagement from "@/components/SPManagement/SPManagement.vue";

export default {
  name: 'SPManagementView',
  components: {
     innerheader,
     SPManagement
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/assets/scss/components/dashboard.scss';
</style>

